<template>
  <div
    class="sidebar"
    :data-color="sidebarItemColor"
    :data-image="sidebarBackgroundImage"
    :style="sidebarStyle"
  >
    <div class="logo">
      <!--
      <a href="#" class="simple-text logo-mini">
        <div class="logo-img">
          <img :src="imgLogo" alt />
        </div>
      </a>

      <a
        href="https://www.weltfern.com"
        target="_blank"
        class="simple-text logo-normal"
        >{{ title }}</a
      >
      -->
      <div style="display: flex; justify-content: center; color: transparent">
        <md-icon
          v-if="username === 'adidas'"
          class="md-size-3x"
          md-src="/static/assets/svg/adidas/logo.svg"
        ></md-icon>
        <v-card-title
          v-if="username !== 'adidas' && editorSidebar"
          style="
            color: #cccccc;
            font-weight: 900;
            font-size: 1em;
            font-size: 22px;
          "
          >{{ title }}</v-card-title
        >
        <md-icon
          v-if="username !== 'adidas' && !editorSidebar"
          class="md-size-3x"
          md-src="/static/assets/svg/augmentable_favicon.svg"
        ></md-icon>
      </div>
    </div>
    <div class="sidebar-wrapper">
      <slot name="content"></slot>
      <md-list class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :to="link.path"
            :link="link"
          ></sidebar-link>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import SidebarLink from "./SidebarLink.vue";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

//import store from "../../store";
import { mapState } from "vuex";

export default {
  components: {
    SidebarLink,
  },
  props: {
    title: {
      type: String,
      default: "augmentable",
    },
    sidebarBackgroundImage: {
      type: String,
      default: require("@/assets/img/sidebar-2.jpg"),
    },
    imgLogo: {
      type: String,
      default: require("@/assets/img/vue-logo.png"),
    },
    sidebarItemColor: {
      type: String,
      default: "green",
      validator: (value) => {
        let acceptedValues = ["", "purple", "blue", "green", "orange", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      username: "",
    };
  },
  mounted() {
    axios
      .get("/dj-rest-auth/user/", {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Token " + this.getAuthCookie("augmentableUserToken") + "",
        },
      })
      .then((response) => {
        console.log(response.data.username);
        this.username = response.data.username;
      })
      .catch((response) => {
        //console.log("user information22");
        console.log(response);
        //console.log(response.data);
      });
  },
  methods: {
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.sidebarBackgroundImage})`,
      };
    },
    ...mapState(["augmentableTheme"]),
    ...mapState(["editorSidebar"]),
  },
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/material-dashboard.scss";

@media screen and (min-width: 991px) {
  .nav-mobile-menu {
    display: none;
  }
}
</style>
